<template>
  <div>
    <Table
      resource="Sale"
      :actions="actions"
      :items="$store.getters['sale/tableData']"
      :detail="$store.getters['sale/detailData']"
      :fields="$store.getters['sale/tableFields']"
      :pagination="$store.state.sale.tablePagination"
      :keyword="$store.state.sale.tableKeyword"
      :loading="$store.state.sale.loadingTable"
      :filter="$store.state.sale.tableFilter"
      :sort="$store.state.sale.tableSort"
      :sort-options="sortOptions"
      @changeFields="changeFields"
      @resetFields="resetFields"
      @filter="filterData"
      @sort="sortData"
      @load="loadData"
      @delete="deleteData"
      @loadDetail="loadDetail"
      @resetDetail="resetDetail"
      @paginate="paginate"
      @search="search"
    />
  </div>
</template>

<script>
import Table from '@/layouts/components/Table.vue'

export default {
  components: {
    Table,
  },
  data() {
    return {
      // Sort
      sortOptions: [
        {
          key: 'created_at', direction: 'desc', label: 'Terbaru', default: true,
        },
        { key: 'created_at', direction: 'asc', label: 'Terlama' },
      ],

      actions: [
        'create',
        'view',
        'update',
        'delete',
      ],
    }
  },
  methods: {
    loadData() {
      return this.$store.dispatch('sale/getTableData')
    },
    loadDetail(id) {
      return this.$store.dispatch('sale/getDetail', id)
    },
    deleteData(id, callback) {
      return this.$store.dispatch('sale/delete', id)
        .then(callback)
    },
    resetDetail() {
      this.$store.commit('sale/SET_DETAIL_DATA', undefined)
    },
    changeFields(val) {
      this.$store.commit('sale/SET_TABLE_FIELDS', val)
    },
    resetFields() {
      this.$store.commit('sale/RESET_TABLE_FIELDS')
    },
    filterData(val) {
      this.$store.commit('sale/SET_TABLE_FILTER', val)
    },
    sortData(val) {
      this.$store.commit('sale/SET_TABLE_SORT', val)
    },
    paginate(val) {
      this.$store.commit('sale/SET_TABLE_PAGINATION', val)
    },
    search(val) {
      this.$store.commit('sale/SET_TABLE_KEYWORD', val)
    },
  },
}
</script>
